// Auto generated file, do not manually modify!
// com.hotpads.admanagement.api.web.external.handler.AdManagementUserSalesforceApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { AdManagementSalesProMappingDto } from '../..';

export const AdManagementUserSalesforceApiHandler_getUserAndSalesProInfo_Path =
  '/api/web/v1/salesforcePaths/getUserAndSalesProInfo';

/**
 * Return Logged in User's Sales Pros' Name(s) and Email(s), as well as customerIds, zrns and SFAccountNames
 */
export const AdManagementUserSalesforceApiHandler_getUserAndSalesProInfo = (client = getClient()) => {
  return httpFrontEndRequest<never, never, Array<AdManagementSalesProMappingDto>>(
    {
      endpoint: AdManagementUserSalesforceApiHandler_getUserAndSalesProInfo_Path,
      method: 'GET',
      contextPath: '/ad-management',
    },
    client,
  );
};
